/* ==========================================================================
   Stivo — Любими (wishlist)

   Съхранение: localStorage, ключ "stivo:wishlist", масив от handle-ове,
   най-новото отпред, максимум 100 записа. Нищо не се пази на сървъра.

   Три отговорности:
     1. Сърцето върху продуктовата карта — показва се САМО оттук. В Liquid
        бутонът излиза с атрибут hidden, така че без JavaScript той изобщо не
        се вижда и картата не показва контрола, която не работи.
     2. Броячът в хедъра — попълва се оттук и стои скрит при нула.
     3. Страницата „Любими" — Liquid не знае кои са продуктите (те са в
        браузъра), затова всеки handle се дърпа през Section Rendering API:
        /products/<handle>?section_id=stivo-wishlist връща СЪЩАТА продуктова
        карта, рендирана от Liquid. Продукт, който вече не съществува (404 или
        празен отговор), тихо пада от списъка.

   Мрежите се пренаписват от други скриптове (филтрите на колекциите сменят
   цялата мрежа), затова новопоявилите се карти се хващат с MutationObserver,
   а не еднократно при зареждане.
   ========================================================================== */
(function () {
  'use strict';

  if (window.StivoWishlist) return;

  var KEY = 'stivo:wishlist';
  var MAX = 100;
  var listeners = [];
  var cache = null;

  /* ---------- съхранение ------------------------------------------------ */

  function read() {
    if (cache) return cache;
    var out = [];
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          for (var i = 0; i < parsed.length && out.length < MAX; i++) {
            var h = parsed[i];
            if (typeof h === 'string' && h && out.indexOf(h) === -1) out.push(h);
          }
        }
      }
    } catch (e) {
      /* частен режим, изключени бисквитки, счупен запис — списъкът е празен */
      out = [];
    }
    cache = out;
    return out;
  }

  function write(list) {
    cache = list.slice(0, MAX);
    try {
      window.localStorage.setItem(KEY, JSON.stringify(cache));
    } catch (e) {
      /* пълно или недостъпно хранилище — паметта в раздела още работи */
    }
    notify();
  }

  function notify() {
    var list = read();
    paintAll();
    paintCounts();
    for (var i = 0; i < listeners.length; i++) {
      try {
        listeners[i](list);
      } catch (e) {
        /* един счупен слушател не бива да спира останалите */
      }
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    if (!handle || has(handle)) return read();
    var list = read().slice();
    list.unshift(handle);
    write(list);
    return cache;
  }

  function remove(handle) {
    var list = read().slice();
    var i = list.indexOf(handle);
    if (i === -1) return list;
    list.splice(i, 1);
    write(list);
    return cache;
  }

  function toggle(handle) {
    if (has(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  /* ---------- сърцето върху картата ------------------------------------- */

  function paint(btn) {
    var handle = btn.getAttribute('data-stivo-wish');
    if (!handle) return;
    var on = has(handle);
    btn.hidden = false;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? btn.getAttribute('data-label-on') : btn.getAttribute('data-label-off');
    if (label) btn.setAttribute('aria-label', label);
  }

  function paintAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-stivo-wish]');
    for (var i = 0; i < nodes.length; i++) paint(nodes[i]);
  }

  function paintCounts() {
    var n = read().length;
    var nodes = document.querySelectorAll('[data-stivo-wish-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n > 99 ? '99+' : String(n);
      nodes[i].hidden = n === 0;
      var link = nodes[i].closest ? nodes[i].closest('a') : null;
      if (link) {
        link.setAttribute(
          'aria-label',
          n === 0 ? 'Любими — списъкът е празен' : 'Любими — ' + n + ' продукта'
        );
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-stivo-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-stivo-wish'));
  });

  /* Друг раздел на същия браузър е пипнал списъка. */
  window.addEventListener('storage', function (e) {
    if (e.key && e.key !== KEY) return;
    cache = null;
    notify();
  });

  /* ---------- страницата „Любими" --------------------------------------- */

  function initPage(root) {
    if (!root || root.dataset.stivoWishReady === 'true') return;
    root.dataset.stivoWishReady = 'true';

    var grid = root.querySelector('[data-stivo-wish-grid]');
    var empty = root.querySelector('[data-stivo-wish-empty]');
    var loading = root.querySelector('[data-stivo-wish-loading]');
    var total = document.querySelector('[data-stivo-wish-total]');
    if (!grid || !empty) return;

    var base = root.getAttribute('data-root') || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    var sectionId = root.getAttribute('data-section-id') || 'stivo-wishlist';

    function setTotal(n) {
      if (!total) return;
      total.hidden = n === 0;
      total.textContent = n === 1 ? '1 продукт' : n + ' продукта';
    }

    function showEmpty() {
      grid.hidden = true;
      grid.innerHTML = '';
      empty.hidden = false;
      setTotal(0);
    }

    /* Една карта = едно рендиране на секцията в контекста на продукта. */
    function fetchCard(handle) {
      var url = base + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-stivo-wish-card]');
          if (!card || !card.querySelector('.stivo-card')) return null;
          return card.innerHTML;
        })
        .catch(function () {
          return null;
        });
    }

    /* Заявките вървят на групи, за да не се пускат 100 наведнъж. */
    function fetchAll(handles) {
      var results = new Array(handles.length);
      var next = 0;
      var LANES = 6;

      function lane() {
        if (next >= handles.length) return Promise.resolve();
        var i = next++;
        return fetchCard(handles[i]).then(function (html) {
          results[i] = html;
          return lane();
        });
      }

      var lanes = [];
      for (var k = 0; k < Math.min(LANES, handles.length); k++) lanes.push(lane());
      return Promise.all(lanes).then(function () {
        return results;
      });
    }

    function render() {
      var handles = read();
      if (!handles.length) {
        showEmpty();
        return;
      }
      if (!window.fetch || !window.DOMParser) {
        /* без fetch остава обяснението — по-добре от празна рамка */
        showEmpty();
        return;
      }

      empty.hidden = true;
      if (loading) loading.hidden = false;

      fetchAll(handles).then(function (cards) {
        if (loading) loading.hidden = true;

        var alive = [];
        var html = '';
        for (var i = 0; i < cards.length; i++) {
          if (!cards[i]) continue;
          alive.push(handles[i]);
          html += '<div class="stivo-wish__cell" data-wish-cell="' + handles[i].replace(/"/g, '&quot;') + '">' + cards[i] + '</div>';
        }

        /* Изчезналите продукти падат тихо от списъка. */
        if (alive.length !== handles.length) {
          cache = alive;
          try {
            window.localStorage.setItem(KEY, JSON.stringify(alive));
          } catch (e) {
            /* без запис списъкът остава верен само за този престой */
          }
          paintCounts();
        }

        if (!alive.length) {
          showEmpty();
          return;
        }

        grid.innerHTML = html;
        grid.hidden = false;
        empty.hidden = true;
        setTotal(alive.length);
        paintAll(grid);
      });
    }

    /* Махането на сърце на самата страница маха и картата — без презареждане. */
    listeners.push(function (list) {
      var cells = grid.querySelectorAll('[data-wish-cell]');
      for (var i = 0; i < cells.length; i++) {
        if (list.indexOf(cells[i].getAttribute('data-wish-cell')) === -1) cells[i].remove();
      }
      var left = grid.querySelectorAll('[data-wish-cell]').length;
      if (!left) {
        if (list.length) render();
        else showEmpty();
      } else {
        setTotal(left);
      }
    });

    render();
  }

  /* ---------- закачане --------------------------------------------------- */

  function enhance() {
    paintAll();
    paintCounts();
    var pages = document.querySelectorAll('[data-stivo-wish-root]');
    for (var i = 0; i < pages.length; i++) initPage(pages[i]);
  }

  var pending = false;
  function scheduleEnhance() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      enhance();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  /* Мрежите се пренаписват от филтрите и от редактора на темата. */
  document.addEventListener('shopify:section:load', scheduleEnhance);
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          scheduleEnhance();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.StivoWishlist = {
    get: function () {
      return read().slice();
    },
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    refresh: enhance,
    subscribe: function (fn) {
      if (typeof fn === 'function') listeners.push(fn);
    }
  };
})();
